<template>
    <div class="container-fluid">
        <div class="row py-3 ">
            <div class="designRowOrga mb-3">
                <div class="h3Organization">
                    <router-link class="back-route" @click="backHandler" :to="this.isDataFlag ? '#':'/profile'">
                        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                    </router-link>
                    &nbsp;
                    <h3>Change Password</h3>
                </div>
            </div>

            <div class="tabcontent">
                <div class="cardContent col-md-4">
                    <div class="NewPasswordH3 mb-4">
                        <h3>New Password</h3>
                    </div>
                    <form @submit.prevent="ChangePassword">
                        <div class="col changePasswordEye1 mb-3 form-group">
                            <label class="mb-2">Enter Old Password</label>
                            <input v-if="isActive1 === false" type="password" class="form-control inputBackgroundOldPassword" v-model="password_reset.old_password" @input="[changeHandler($event, errors, 'old_password') , setData($event,'old_password')]" id="old_password" name="old_password" placeholder="Enter Old Password">
                            <input v-if="isActive1 === true" type="text" class="form-control inputBackgroundOldPassword" v-model="password_reset.old_password" @input="[changeHandler($event, errors, 'old_password'), setData($event,'old_password')]" id="old_password" name="old_password" placeholder="Enter Old Password">
                            <span v-if="isActive1 === false" class="p-viewer1" @click="toggle1">
                                <font-awesome-icon :icon="['fas', 'eye']" id="togglePassword" size="lg" />
                            </span>

                            <span v-if="isActive1 === true" class="p-viewer1" @click="toggle1">
                                <font-awesome-icon :icon="['fas', 'eye-slash']" id="togglePassword" size="lg" />
                            </span>

                            <div  v-if="errors['old_password'].length > 0" >
                                <div v-for="msg in errors['old_password']" class="text-danger mb-3" >{{msg}}</div>
                            </div>
                        </div>
                        <div class="col changePasswordEye2 pt-3 mb-3">
                            <label class="mb-2">Enter New Password</label>
                            <input v-if="isActive2 === false" type="password" class="form-control inputBackgroundNewPassword" v-model="password_reset.new_password" @input="[changeHandler($event, errors, 'new_password') , setData($event,'new_password')]" id="new_password" name="new_password" placeholder="Enter New Password">
                            <input v-if="isActive2 === true" type="text" class="form-control inputBackgroundNewPassword" v-model="password_reset.new_password" @input="[changeHandler($event, errors, 'new_password') , setData($event,'new_password')]" id="new_password" name="new_password" placeholder="Enter New Password">
                            <span v-if="isActive2 === false" class="p-viewer2" @click="toggle2">
                                            <font-awesome-icon :icon="['fas', 'eye']" id="togglePassword" size="lg" />
                                        </span>
                            <span v-if="isActive2 === true" class="p-viewer2" @click="toggle2">
                                            <font-awesome-icon :icon="['fas', 'eye-slash']" id="togglePassword" size="lg" />
                                        </span>
                            <div  v-if="errors['new_password'].length > 0" >
                                <div v-for="msg in errors['new_password']" class="text-danger" >{{msg}}<br></div>
                            </div>
                        </div>
                        <div class="col changePasswordEye3 pt-3 mb-5">
                            <label class="mb-2">Confirm New Password</label>
                            <input v-if="isActive3 === false" type="password" class="form-control inputBackgroundConfirmPassword" v-model="password_reset.new_password_confirmation" @input="[changeHandler($event, errors, 'new_password_confirmation') , setData($event,'new_password_confirmation')]" id="new_password_confirmation" name="new_password_confirmation" placeholder="Confirm New Password">
                            <input v-if="isActive3 === true" type="text" class="form-control inputBackgroundConfirmPassword" v-model="password_reset.new_password_confirmation" @input="[changeHandler($event, errors, 'new_password_confirmation') , setData($event,'new_password_confirmation')]" id="new_password_confirmation" name="new_password_confirmation" placeholder="Confirm New Password">
                            <span v-if="isActive3 === false" class="p-viewer3" @click="toggle3">
                                            <font-awesome-icon :icon="['fas', 'eye']" id="togglePassword" size="lg" />
                                        </span>
                            <span v-if="isActive3 === true" class="p-viewer3" @click="toggle3">
                                            <font-awesome-icon :icon="['fas', 'eye-slash']" id="togglePassword" size="lg" />
                                        </span>
                            <div  v-if="errors['new_password_confirmation'].length > 0" >
                                <div v-for="msg in errors['new_password_confirmation']" class="text-danger" >{{msg}}</div>
                            </div>
                        </div>
                        <div class="col d-flex justify-content-center btnOrganization">
                            <button class="w-100">Change Password</button>
                        </div>
                    </form>
                    <div  v-if="errorMessages.length > 0" class="error-container">
                        <div v-for="msg in errorMessages" class="text-danger my-4" >{{msg}}</div>
                    </div>
                    <div v-if="errorMsg">{{errorMsg}}</div>
                    <div v-else>{{errorMsg}}</div>
                </div>
                <AlartModal v-if="showModal" :message="message" :imagePath="imagePath" @close-modal="showModal = false"/>
            </div>
        </div>
    </div>
    <ConfirmationModal v-if="this.isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import repository from "../../../../api-services/repository";
    import AlartModal from "../../../components/AlartModal";
    import changeHandler from '../../../../validation/changePasswordValidation';
    import ConfirmationModal from '../../../components/ConfirmationModal';
    import {computed} from "vue";
    import router from "../../../../router";
    import store from "../../../../store";

    export default {
        name:'change-password',
        data(){
            return {
                changeHandler,
                isActive1:false,
                isActive2:false,
                isActive3:false,
                showModal:false,
                imagePath:null,
                message:null,
                password_reset:{
                    old_password:null,
                    new_password:null,
                    new_password_confirmation:null,
                },
                errors:{
                    old_password:[],
                    new_password:[],
                    new_password_confirmation:[],
                    isError: false
                },
                errorMessages:[],
                responseErrorMessage:'',
                showErrorModal:false,
                errorMsg:'',
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{
                    old_password: false,
                    new_password: false,
                    new_password_confirmation:false
                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        mounted(){

        },
        components:{
            AlartModal,
            ConfirmationModal
        },
        methods:{
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            setData(e, type) {
                let val = e.target.value;
                if (type === 'old_password') {
                    if (val !== '') {
                        this.isData.old_password = true;
                    } else {
                        this.isData.old_password = false;
                    }
                }

                if (type === 'new_password') {
                    if (val !== '') {
                        this.isData.new_password = true;
                    } else {
                        this.isData.new_password = false;
                    }
                }

                if (type === 'new_password_confirmation') {
                    if (val !== '') {
                        this.isData.new_password_confirmation = true;
                    } else {
                        this.isData.new_password_confirmation = false;
                    }
                }
                if (this.isData.old_password || this.isData.new_password || this.isData.new_password_confirmation) {
                    this.$store.dispatch('setDataFlag', true);
                    console.log('data ==>> ')
                } else {
                    this.$store.dispatch('setDataFlag', false);
                    console.log('no data ==>> ');
                }

            },
            async confirmModalHandler (event) {
                this.isFull = false;
                await this.$store.dispatch('setConfirmModal', false);
                if(event){
                    await this.$store.dispatch('setDataFlag', false);
                    await this.$router.push('/' + store.state.settings.currentRoute);
                }
            },
            toggle1() {
                if(!this.isActive1) {
                    this.isActive1 = true;
                } else {
                    this.isActive1 = false;
                }
            },
            toggle2() {
                if(!this.isActive2) {
                    this.isActive2 = true;
                } else {
                    this.isActive2 = false;
                }
            },
            toggle3() {
                if(!this.isActive3) {
                    this.isActive3 = true;
                } else {
                    this.isActive3 = false;
                }
            },
            ChangePassword:async function(){
                try{
                    if(this.password_reset.old_password == null || this.password_reset.new_password == null || this.password_reset.new_password_confirmation == null){
                        this.showModal = true;
                        this.imagePath = 'close.png';
                        this.message = 'Please Fill Data Correctly';
                    }else{
                        if(!this.errors.isError) {
                            const response = await repository.changePassowrd(this.password_reset);
                            if(response.status === 200){
                                this.message = response.data.message;
                                this.showModal = true;
                                this.imagePath = 'okImage.svg';
                                await this.$store.dispatch('setDataFlag', false);
                                setTimeout(() => {
                                    this.$router.push({name: 'profile-page'});
                                } , 3000);
                            }
                        }
                    }
                }catch(e){
                    if(e.response.data.errors){
                        if(e.response.data.errors.old_password  || e.response.data.errors.new_password || e.response.data.errors.new_password_confirmation){
                            if(e.response.data.errors.old_password)
                                e.response.data.errors.old_password.forEach((err,idx) => { this.errors['old_password'][idx] = `* ${err}`});
                            if(e.response.data.errors.new_password)
                                e.response.data.errors.new_password.forEach((err,idx) => {this.errors['new_password'][idx] = `* ${err}`});
                            if(e.response.data.errors.new_password_confirmation)
                                e.response.data.errors.new_password_confirmation.forEach((err,idx) => {this.errors['new_password_confirmation'][idx] = `* ${err}`});
                        }else{
                            let idx = 0;
                            for (const property in e.response.data.errors) {
                                let record = property.split('.')[0];
                                console.log(`record ${+record + 1}: ${e.response.data.errors[property]}`);
                                this.errors['email'][idx++] = `* record ${+record + 1}: ${e.response.data.errors[property]}` + '\n';
                            }
                        }
                    }else if(e.response.data){
                        this.errorMsg = e.response.data.message;
                        this.showErrorModal = true;
                        this.responseErrorMessage = e.response.data.message
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .btnOrganization button{
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }
    .changePasswordEye3 .inputBackgroundConfirmPassword{
        background-color: transparent;
        padding: 13px;
        color: var(--main-color);
    }
    .changePasswordEye3 .p-viewer3{
        cursor:pointer;
        color:#e37450;
        position: absolute;
        top: 61px;
        right: 10px;
    }
    .changePasswordEye3{
        position: relative;
    }
    .changePasswordEye2 .inputBackgroundNewPassword{
        background-color: transparent;
        padding: 13px;
        color: var(--main-color);
    }
    .changePasswordEye2 .p-viewer2{
        cursor:pointer;
        color:#e37450;
        position: absolute;
        top: 61px;
        right: 10px;
    }
    .changePasswordEye2{
        position: relative;
    }
    .changePasswordEye1 .inputBackgroundOldPassword{
        background-color: transparent;
        padding: 13px;
        color: var(--main-color);
    }
    .changePasswordEye1 .p-viewer1{
        cursor:pointer;
        color:#e37450;
        position: absolute;
        top: 45px;
        right: 10px;
        z-index: 2;
    }
    .changePasswordEye1{
        position: relative;
    }
    .cardContent{
        border:1px solid var(--border-color-profile-icon);
        padding: 20px;
        border-radius: 10px;
    }
    .designRowOrga{
        padding: 0px;
    }
    .tabcontent {
        border-radius: 20px;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        padding: 23px;
        /*height: calc(100vh - 15rem);*/
    }
    .h3Organization button{
        border:none;
        color:#fff;
        background-color: transparent;
    }
    .h3Organization{
        display: flex;
        flex-direction: row;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .cardContent{
            width: 50%;
        }
    }

    @media only screen and (max-width: 1170px) and (min-width: 1024px) {
        .cardContent{
            width: 50%;
        }
    }
</style>